import { Badge } from "@radix-ui/themes"
import { capitalize } from "@/lib/strings"

interface StatusBadgeProps {
  status: string
  color: "gray" | "blue" | "green" | "red" | "yellow" | "orange" | "purple"
}

export default function StatusBadge({ status, color }: StatusBadgeProps) {
  return <Badge color={color}>{capitalize(status)}</Badge>
}
